// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iWzo8","col":"styles_col__2QOht","actions":"styles_actions__s2qfQ","conflict":"styles_conflict__2fGc_"};